var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15208_69959)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6665 11.2807V13.2807C14.6672 13.4664 14.6292 13.6502 14.5548 13.8203C14.4804 13.9904 14.3713 14.1431 14.2345 14.2686C14.0977 14.3941 13.9362 14.4897 13.7603 14.5492C13.5844 14.6087 13.398 14.6308 13.2131 14.614C11.1617 14.3911 9.19113 13.6901 7.45979 12.5674C5.84901 11.5438 4.48335 10.1782 3.45979 8.56738C2.33311 6.82819 1.63195 4.84805 1.41313 2.78738C1.39647 2.60303 1.41838 2.41722 1.47746 2.2418C1.53654 2.06637 1.63151 1.90518 1.7563 1.76846C1.8811 1.63175 2.033 1.52252 2.20232 1.44773C2.37164 1.37294 2.55469 1.33422 2.73979 1.33405H4.73979C5.06333 1.33086 5.37699 1.44543 5.6223 1.6564C5.86761 1.86737 6.02784 2.16035 6.07313 2.48072C6.15754 3.12076 6.31409 3.7492 6.53979 4.35405C6.62949 4.59266 6.6489 4.85199 6.59573 5.1013C6.54256 5.35061 6.41903 5.57946 6.23979 5.76072L5.39313 6.60738C6.34216 8.27641 7.7241 9.65835 9.39313 10.6074L10.2398 9.76072C10.4211 9.58147 10.6499 9.45795 10.8992 9.40478C11.1485 9.35161 11.4078 9.37102 11.6465 9.46072C12.2513 9.68642 12.8797 9.84297 13.5198 9.92738C13.8436 9.97307 14.1394 10.1362 14.3508 10.3857C14.5622 10.6352 14.6746 10.9538 14.6665 11.2807Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15208_69959"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phoneIcon.9cb0220295eb0cbc67a14592e047c31e.svg";
export { ForwardRef as ReactComponent };